module.exports = __webpack_public_path__ + "img/banner-right.d141a00e.svg";